var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AboutUs"}},[_c('headerVue'),_vm._m(0),_c('footerVue')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"bottom"},[_c('div',[_c('h2',[_vm._v("社内监督邮箱：93shx@163.com")]),_c('h2',[_vm._v("联系电话：63903370 "),_c('span',[_vm._v("|")]),_vm._v(" 63903380")])])])])
}]

export { render, staticRenderFns }